import React, { useEffect, useState } from 'react';
import { Clock3Icon } from 'lucide-react';
type TimeLeft = {
  hours: number;
  minutes: number;
  seconds: number;
};
const initialTime: TimeLeft = {
  hours: 23,
  minutes: 1,
  seconds: 2
};
export function LaunchUrgency() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(initialTime);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const totalSeconds = current.hours * 3600 + current.minutes * 60 + current.seconds;
        if (totalSeconds <= 0) return current;
        const next = totalSeconds - 1;
        return {
          hours: Math.floor(next / 3600),
          minutes: Math.floor(next % 3600 / 60),
          seconds: next % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <aside aria-label="Urgencia de precio de lanzamiento" className="mx-auto mb-9 max-w-2xl rounded-3xl border border-brand-yellow/70 bg-brand-deep px-5 py-6 text-brand-cream shadow-[0_16px_34px_rgba(23,59,43,.18)] sm:px-8" data-id="element-163" data-mp="1svpgra7sg3ga">
      <div className="flex items-center justify-center gap-2 text-center text-xs font-bold tracking-[.12em] text-brand-yellow sm:text-sm" data-id="element-164" data-mp="1ykrazw35511f">
        <Clock3Icon className="h-4 w-4" aria-hidden="true" data-id="element-165" data-mp="27itmj5ki3c2y" />
        PRECIO DE LANZAMIENTO — CIERRA EN:
      </div>

      <div className="mt-5 flex items-start justify-center gap-2.5 sm:gap-4" aria-live="polite" data-id="element-166" data-mp="2chd6j0fjadso">
        <TimeUnit value={timeLeft.hours} label="Horas" data-id="element-167" data-mp="1ft6x807o2x82" />
        <TimeSeparator data-id="element-168" data-mp="1jtqsszcldss3" />
        <TimeUnit value={timeLeft.minutes} label="Min" data-id="element-169" data-mp="1jt90uewyq0pz" />
        <TimeSeparator data-id="element-170" data-mp="1jro6oqek8jsn" />
        <TimeUnit value={timeLeft.seconds} label="Seg" data-id="element-171" data-mp="1ot3qyg8wym9z" />
      </div>

      <p className="mt-5 text-center text-sm text-brand-cream/80" data-id="element-172" data-mp="1oqqz9bdcsxjq">
        Después sube $38.990 ARS.{' '}
        <strong className="text-brand-yellow" data-id="element-173" data-mp="1tln1138e6za1">No vuelve.</strong>
      </p>

      <div className="mt-6 border-t border-brand-cream/15 pt-5" data-id="element-174" data-mp="w3n0ho4utfge">
        <div className="flex items-end justify-between gap-4 text-sm" data-id="element-175" data-mp="112hiwoywt1zz">
          <div data-id="element-176" data-mp="24e6q6028f3mj">
            <p className="font-semibold text-brand-cream" data-id="element-177" data-mp="24dn7ui8o6d7z">
              Cupos al precio de lanzamiento
            </p>
            <p className="mt-1 text-xs text-brand-cream/65" data-id="element-178" data-mp="1ze0wkecej71t">
              87% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
          <span className="shrink-0 rounded-full bg-brand-yellow px-3 py-1 text-xs font-bold text-brand-deep" data-id="element-179" data-mp="294vi1ghtq2m7">
            Quedan pocos
          </span>
        </div>
        <div className="mt-3 h-2 overflow-hidden rounded-full bg-brand-cream/20" role="progressbar" aria-label="Cupos al precio de lanzamiento tomados" aria-valuemin={0} aria-valuemax={100} aria-valuenow={87} data-id="element-180" data-mp="1lfkpunejhgjo">
          <div className="h-full w-[87%] rounded-full bg-brand-yellow" data-id="element-181" data-mp="1udwc6d8dhs6b" />
        </div>
      </div>
    </aside>;
}
type TimeUnitProps = {
  value: number;
  label: string;
};
function TimeUnit({
  value,
  label
}: TimeUnitProps) {
  return <div className="min-w-[58px] text-center sm:min-w-[72px]" data-id="element-182" data-mp="30wbcfwpmgtmz">
      <div className="font-display text-4xl font-bold leading-none text-brand-yellow tabular-nums sm:text-5xl" data-id="element-183" data-mp="30y5p6nqqpffz">
        {String(value).padStart(2, '0')}
      </div>
      <div className="mt-1 text-[10px] font-semibold uppercase tracking-[.12em] text-brand-cream/65" data-id="element-184" data-mp="3dfq5ojy5pajk">
        {label}
      </div>
    </div>;
}
function TimeSeparator() {
  return <span className="mt-1 font-display text-3xl font-bold text-brand-yellow/70 sm:text-4xl" aria-hidden="true" data-id="element-185" data-mp="34dgxw1u9vv9v">
      :
    </span>;
}